export { calculator_used, job_applied };

function calculator_used(element) {
	dataLayer.push({
		'event': 'calculator_used',
		'setting_name': element.dataset.name,
		'setting_value': element.dataset.value
	});
}

function job_applied(name, id) {
	dataLayer.push({
        event: "job_applied",
        job_name: name,
        job_id: id
    });
}
